(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["basisfragebogen-erstkontakt-js"] && !Shopify.designMode) return;
  try {
    
(function () {
  const storageKey = 'basisfragebogen_erstkontakt_v1';

  function getForm() {
    return document.getElementById('basisForm');
  }

  function cleanText(text) {
    return String(text || '').replace(/\s+/g, ' ').trim();
  }

  function getSectionTitle(el) {
    const card = el.closest('section.card');
    if (!card) return 'Allgemeines';
    const h2 = card.querySelector('h2');
    return h2 ? cleanText(h2.textContent) : 'Allgemeines';
  }

  function getQuestionLabel(el) {
    const directLabel = el.closest('label.field');
    if (directLabel) {
      const clone = directLabel.cloneNode(true);
      clone.querySelectorAll('input, textarea, select').forEach(function (node) {
        node.remove();
      });
      return cleanText(clone.textContent);
    }

    const field = el.closest('.field');
    if (field) {
      const strong = field.querySelector('strong');
      if (strong) return cleanText(strong.textContent);
    }

    const scaleRow = el.closest('.scale-row');
    if (scaleRow) {
      const strong = scaleRow.querySelector('strong');
      if (strong) return cleanText(strong.textContent);
    }

    const card = el.closest('section.card');
    if (card) {
      const h2 = card.querySelector('h2');
      if (h2) return cleanText(h2.textContent);
    }

    return el.name || 'Feld';
  }

  function getOptionLabel(el) {
    const label = el.closest('label');
    if (!label) return el.value || '';
    const clone = label.cloneNode(true);
    clone.querySelectorAll('input').forEach(function (node) {
      node.remove();
    });
    return cleanText(clone.textContent) || el.value || '';
  }

  function formDataAsObject() {
    const form = getForm();
    if (!form) {
      alert('Das Formular wurde nicht gefunden. Bitte prüfen, ob die Seite das Element mit id="basisForm" enthält.');
      return null;
    }

    const data = {};
    const elements = Array.from(form.elements).filter(function (el) {
      return el.name;
    });

    elements.forEach(function (el) {
      if (el.type === 'checkbox') {
        if (!data[el.name]) data[el.name] = [];
        if (el.checked) data[el.name].push(el.value);
      } else if (el.type === 'radio') {
        if (el.checked) {
          data[el.name] = el.value;
        } else if (!(el.name in data)) {
          data[el.name] = '';
        }
      } else {
        data[el.name] = el.value;
      }
    });

    data._formular = 'Basisfragebogen Erstkontakt';
    data._exportiert_am = new Date().toISOString();

    return data;
  }

  function formDataAsPrintableRows() {
    const form = getForm();
    if (!form) return [];

    const elements = Array.from(form.elements).filter(function (el) {
      return el.name && !['button', 'submit', 'reset'].includes(el.type);
    });

    const names = Array.from(new Set(elements.map(function (el) {
      return el.name;
    })));

    const rows = [];

    names.forEach(function (name) {
      const group = elements.filter(function (el) {
        return el.name === name;
      });

      if (!group.length) return;

      const first = group[0];
      const label = getQuestionLabel(first);
      let value = '';

      if (first.type === 'checkbox') {
        const selected = group
          .filter(function (el) {
            return el.type === 'checkbox' && el.checked;
          })
          .map(function (el) {
            return getOptionLabel(el);
          })
          .filter(Boolean);

        value = selected.length ? selected.join(', ') : '';
      } else if (first.type === 'radio') {
        const selectedRadio = group.find(function (el) {
          return el.type === 'radio' && el.checked;
        });

        value = selectedRadio ? getOptionLabel(selectedRadio) : '';
      } else if (first.type === 'range') {
        value = first.value ? first.value + ' / 10' : '';
      } else {
        value = first.value || '';
      }

      value = String(value || '').trim();

      if (value) {
        rows.push({
          section: getSectionTitle(first),
          label: label,
          value: value
        });
      }
    });

    return rows;
  }

  function escapeHtml(text) {
    return String(text || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function renderPrintableHtml() {
    const rows = formDataAsPrintableRows();
    const data = formDataAsObject() || {};
    const name = data.name || 'Klient/in';
    const datum = data.datum || new Date().toLocaleDateString('de-DE');

    let currentSection = '';
    let body = '';

    rows.forEach(function (row) {
      if (row.section !== currentSection) {
        currentSection = row.section;
        body += '<h2>' + escapeHtml(currentSection) + '</h2>';
      }

      body += '<div class="qa">';
      body += '<div class="question">' + escapeHtml(row.label) + '</div>';
      body += '<div class="answer">' + escapeHtml(row.value).replace(/\n/g, '<br>') + '</div>';
      body += '</div>';
    });

    if (!rows.length) {
      body = '<p>Es wurden noch keine Antworten eingetragen.</p>';
    }

    return '<!doctype html>' +
      '<html lang="de">' +
      '<head>' +
      '<meta charset="utf-8">' +
      '<title>Basisfragebogen – Antworten</title>' +
      '<style>' +
      'body{font-family:system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;color:#1d1f23;line-height:1.45;margin:32px;}' +
      'h1{font-size:26px;margin:0 0 8px;}' +
      '.meta{color:#667085;margin:0 0 28px;font-size:13px;}' +
      'h2{font-size:19px;margin:28px 0 12px;padding-top:12px;border-top:1px solid #d9dee7;}' +
      '.qa{break-inside:avoid;border-bottom:1px solid #eef0f3;padding:10px 0 12px;}' +
      '.question{font-weight:750;color:#24313f;margin-bottom:5px;}' +
      '.answer{white-space:normal;color:#111827;}' +
      '.hint{margin-top:28px;padding:12px 14px;border:1px solid #b9d8d4;background:#e7f3f1;border-radius:12px;color:#164a46;font-size:13px;}' +
      '@media print{body{margin:18mm;} .qa{break-inside:avoid;} }' +
      '</style>' +
      '</head>' +
      '<body>' +
      '<h1>Basisfragebogen – Erstkontakt</h1>' +
      '<p class="meta">Name: ' + escapeHtml(name) + '<br>Datum: ' + escapeHtml(datum) + '<br>Erzeugt: ' + escapeHtml(new Date().toLocaleString('de-DE')) + '</p>' +
      body +
      '<div class="hint">Diese PDF-Zusammenfassung wurde aus den aktuell im Browser sichtbaren Formularangaben erzeugt. Checkboxen, Auswahlfelder und Skalen werden als Textwerte ausgegeben.</div>' +
      '</body>' +
      '</html>';
  }

  function downloadPrintableHtml() {
    const data = formDataAsObject() || {};
    const rawName = data.name || 'klient';
    const safeName = rawName
      .replace(/[^a-z0-9\-_äöüß ]/gi, '')
      .trim()
      .replace(/\s+/g, '_') || 'klient';

    const blob = new Blob([renderPrintableHtml()], { type: 'text/html;charset=utf-8' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = 'basisfragebogen_' + safeName + '_druckfassung.html';

    document.body.appendChild(link);
    link.click();
    link.remove();

    URL.revokeObjectURL(url);
    flash('Druckfassung wurde als HTML-Datei erstellt.');
  }

  function printFilledReport() {
    const htmlText = renderPrintableHtml();
    const printWindow = window.open('', '_blank');

    if (!printWindow) {
      downloadPrintableHtml();
      alert('Das Druckfenster wurde blockiert. Stattdessen wurde eine HTML-Zusammenfassung heruntergeladen. Diese Datei öffnen und dann als PDF speichern.');
      return;
    }

    printWindow.document.open();
    printWindow.document.write(htmlText);
    printWindow.document.close();

    setTimeout(function () {
      try {
        printWindow.focus();
        printWindow.print();
      } catch (e) {
        console.warn('Druck konnte nicht automatisch gestartet werden.', e);
      }
    }, 700);
  }

  function fillForm(data) {
    const form = getForm();
    if (!form || !data) return;

    const elements = Array.from(form.elements).filter(function (el) {
      return el.name;
    });

    elements.forEach(function (el) {
      const value = data[el.name];

      if (el.type === 'checkbox') {
        el.checked = Array.isArray(value) && value.includes(el.value);
      } else if (el.type === 'radio') {
        el.checked = value === el.value;
      } else if (value !== undefined && value !== null) {
        el.value = value;
        if (el.type === 'range') {
          syncRange(el);
        }
      }
    });

    updateProgress();
  }

  function syncRange(input) {
    if (!input) return;
    const valueBox = input.parentElement ? input.parentElement.querySelector('.scale-value') : null;
    if (valueBox) valueBox.textContent = input.value;
  }

  function syncAllRanges() {
    const form = getForm();
    if (!form) return;

    Array.from(form.querySelectorAll('input[type="range"]')).forEach(function (input) {
      syncRange(input);
    });
  }

  function saveForm() {
    const data = formDataAsObject();
    if (!data) return;

    try {
      localStorage.setItem(storageKey, JSON.stringify(data));
      flash('Zwischengespeichert.');
    } catch (error) {
      alert('Die Eingaben konnten nicht zwischengespeichert werden. Möglicherweise blockiert der Browser lokale Speicherung.');
      console.error(error);
    }
  }

  function loadSaved() {
    try {
      const saved = localStorage.getItem(storageKey);
      if (saved) fillForm(JSON.parse(saved));
    } catch (error) {
      console.warn('Gespeicherte Daten konnten nicht geladen werden.', error);
    }
  }

  function clearSaved() {
    const form = getForm();
    if (!confirm('Gespeicherte Eingaben auf diesem Gerät wirklich löschen?')) return;

    try {
      localStorage.removeItem(storageKey);
      if (form) form.reset();
      syncAllRanges();
      updateProgress();
      flash('Gespeicherte Daten gelöscht.');
    } catch (error) {
      alert('Die gespeicherten Daten konnten nicht gelöscht werden.');
      console.error(error);
    }
  }

  function downloadJSON() {
    const data = formDataAsObject();
    if (!data) return;

    const json = JSON.stringify(data, null, 2);
    const blob = new Blob([json], { type: 'application/json;charset=utf-8' });
    const url = URL.createObjectURL(blob);

    const rawName = data.name || 'klient';
    const safeName = rawName
      .replace(/[^a-z0-9\-_äöüß ]/gi, '')
      .trim()
      .replace(/\s+/g, '_') || 'klient';

    const link = document.createElement('a');
    link.href = url;
    link.download = 'basisfragebogen_' + safeName + '.json';

    document.body.appendChild(link);
    link.click();
    link.remove();

    URL.revokeObjectURL(url);

    flash('JSON-Datei wurde erstellt.');
  }

  function updateProgress() {
    const form = getForm();
    if (!form) return;

    const elements = Array.from(form.elements).filter(function (el) {
      return el.name && !['button', 'submit', 'reset'].includes(el.type);
    });

    const names = Array.from(new Set(elements.map(function (el) {
      return el.name;
    })));

    let filled = 0;

    names.forEach(function (name) {
      const group = elements.filter(function (el) {
        return el.name === name;
      });

      const anyFilled = group.some(function (el) {
        if (el.type === 'checkbox' || el.type === 'radio') return el.checked;
        if (el.type === 'range') return Number(el.value) > 0;
        return String(el.value || '').trim().length > 0;
      });

      if (anyFilled) filled++;
    });

    const percent = names.length ? Math.round((filled / names.length) * 100) : 0;

    const progressText = document.getElementById('progressText');
    const progressBar = document.getElementById('progressBar');

    if (progressText) progressText.textContent = percent + '%';
    if (progressBar) progressBar.style.width = percent + '%';
  }

  let flashTimer;

  function flash(text) {
    clearTimeout(flashTimer);

    const old = document.getElementById('bf-flashMessage');
    if (old) old.remove();

    const msg = document.createElement('div');
    msg.id = 'bf-flashMessage';
    msg.textContent = text;
    msg.style.position = 'fixed';
    msg.style.right = '18px';
    msg.style.bottom = '18px';
    msg.style.background = '#176b67';
    msg.style.color = 'white';
    msg.style.padding = '12px 16px';
    msg.style.borderRadius = '999px';
    msg.style.boxShadow = '0 12px 35px rgba(0,0,0,.18)';
    msg.style.zIndex = '999999';
    msg.style.fontFamily = 'system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif';

    document.body.appendChild(msg);

    flashTimer = setTimeout(function () {
      msg.remove();
    }, 2200);
  }

  function bindButtons() {
    const form = getForm();
    if (!form) {
      console.warn('Basisfragebogen: Formular mit id="basisForm" nicht gefunden.');
      return;
    }

    const buttons = Array.from(document.querySelectorAll('button'));

    buttons.forEach(function (button) {
      const text = (button.textContent || '').trim().toLowerCase();

      button.removeAttribute('onclick');
      button.onclick = null;

      if (text.includes('zwischenspeichern')) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          saveForm();
        }, true);
      }

      if (text.includes('antworten herunterladen')) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          downloadJSON();
        }, true);
      }

      if (text.includes('gespeicherte daten löschen')) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          clearSaved();
        }, true);
      }

      if (text.includes('drucken')) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          printFilledReport();
        }, true);
      }
    });

    Array.from(form.querySelectorAll('input[type="range"]')).forEach(function (input) {
      input.addEventListener('input', function () {
        syncRange(input);
        updateProgress();
        try {
          const data = formDataAsObject();
          if (data) localStorage.setItem(storageKey, JSON.stringify(data));
        } catch (error) {
          console.warn('Automatische Zwischenspeicherung nicht möglich.', error);
        }
      });
      syncRange(input);
    });

    form.addEventListener('input', function () {
      updateProgress();
      try {
        const data = formDataAsObject();
        if (data) localStorage.setItem(storageKey, JSON.stringify(data));
      } catch (error) {
        console.warn('Automatische Zwischenspeicherung nicht möglich.', error);
      }
    });

    form.addEventListener('change', function () {
      updateProgress();
      try {
        const data = formDataAsObject();
        if (data) localStorage.setItem(storageKey, JSON.stringify(data));
      } catch (error) {
        console.warn('Automatische Zwischenspeicherung nicht möglich.', error);
      }
    });

    loadSaved();
    syncAllRanges();
    updateProgress();

    console.log('Basisfragebogen: JavaScript erfolgreich geladen.');
  }

  window.saveForm = saveForm;
  window.downloadJSON = downloadJSON;
  window.clearSaved = clearSaved;
  window.updateProgress = updateProgress;
  window.printFilledReport = printFilledReport;
  window.downloadPrintableHtml = downloadPrintableHtml;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindButtons);
  } else {
    bindButtons();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["produktberatung-js"] && !Shopify.designMode) return;
  try {
    
(function () {
  const storageKey = 'produktberatung_fragebogen_v3';

  const requiredFields = [
    {
      name: 'pseudonym',
      label: 'Pseudonym oder Vorname',
      type: 'value'
    },
    {
      name: 'email',
      label: 'E-Mail für Rückfragen',
      type: 'value'
    },
    {
      name: 'alter',
      label: 'Alter',
      type: 'value'
    },
    {
      name: 'gewicht',
      label: 'Gewicht',
      type: 'value'
    },
    {
      name: 'schwangerschaft',
      label: 'Schwangerschaft / Stillzeit / Kinderwunsch',
      type: 'checked'
    },
    {
      name: 'wichtigstes_ziel',
      label: 'Wichtigstes Ziel',
      type: 'value'
    },
    {
      name: 'medikamente_details',
      label: 'Medikamente aktuell',
      type: 'value',
      hint: 'Bitte eintragen oder „keine“ schreiben.'
    },
    {
      name: 'unvertraeglichkeiten',
      label: 'Unverträglichkeiten / Allergien / frühere Nebenwirkungen',
      type: 'value',
      hint: 'Bitte eintragen oder „keine bekannt“ schreiben.'
    },
    {
      name: 'aktuelle_supplements',
      label: 'Aktuelle Nahrungsergänzungsmittel',
      type: 'value',
      hint: 'Bitte eintragen oder „keine“ schreiben.'
    },
    {
      name: 'empfehlungsstil',
      label: 'Gewünschter Empfehlungsstil',
      type: 'value'
    }
  ];

  const requiredConfirmations = [
    {
      name: 'bestaetigung',
      value: 'keine medizinische Behandlung',
      label: 'Bestätigung: Produktempfehlung ersetzt keine medizinische Behandlung.'
    },
    {
      name: 'bestaetigung',
      value: 'geschützte Übermittlung',
      label: 'Bestätigung: geschützter Upload-Weg.'
    }
  ];

  function getForm() {
    return document.getElementById('produktberatungForm');
  }

  function cleanText(text) {
    return String(text || '').replace(/\s+/g, ' ').trim();
  }

  function getSectionTitle(el) {
    const card = el.closest('section.card');
    if (!card) return 'Allgemeines';
    const h2 = card.querySelector('h2');
    return h2 ? cleanText(h2.textContent) : 'Allgemeines';
  }

  function getQuestionLabel(el) {
    const scoreField = el.closest('label.score-field');
    if (scoreField) {
      const span = scoreField.querySelector('span');
      if (span) return cleanText(span.textContent);
    }

    const directLabel = el.closest('label.field');
    if (directLabel) {
      const clone = directLabel.cloneNode(true);
      clone.querySelectorAll('input, textarea, select').forEach(function (node) {
        node.remove();
      });
      return cleanText(clone.textContent);
    }

    const field = el.closest('.field');
    if (field) {
      const strong = field.querySelector('strong');
      if (strong) return cleanText(strong.textContent);
    }

    const card = el.closest('section.card');
    if (card) {
      const h2 = card.querySelector('h2');
      if (h2) return cleanText(h2.textContent);
    }

    return el.name || 'Feld';
  }

  function getOptionLabel(el) {
    const label = el.closest('label');
    if (!label) return el.value || '';
    const clone = label.cloneNode(true);
    clone.querySelectorAll('input').forEach(function (node) {
      node.remove();
    });
    return cleanText(clone.textContent) || el.value || '';
  }

  function findFieldElement(name) {
    const form = getForm();
    if (!form) return null;
    return form.querySelector('[name="' + name + '"]');
  }

  function clearMissingHighlights() {
    const form = getForm();
    if (!form) return;

    form.querySelectorAll('.pb-missing-field').forEach(function (el) {
      el.classList.remove('pb-missing-field');
    });
  }

  function highlightField(name) {
    const el = findFieldElement(name);
    if (!el) return;

    const container =
      el.closest('label.field') ||
      el.closest('.field') ||
      el.closest('label.score-field') ||
      el.closest('section.card') ||
      el;

    container.classList.add('pb-missing-field');
  }

  function fieldHasValue(name) {
    const form = getForm();
    if (!form) return false;

    const elements = Array.from(form.querySelectorAll('[name="' + name + '"]'));

    if (!elements.length) return false;

    return elements.some(function (el) {
      if (el.type === 'checkbox' || el.type === 'radio') {
        return el.checked;
      }

      return String(el.value || '').trim().length > 0;
    });
  }

  function confirmationChecked(name, value) {
    const form = getForm();
    if (!form) return false;

    const boxes = Array.from(form.querySelectorAll('input[type="checkbox"][name="' + name + '"]'));

    return boxes.some(function (box) {
      return box.checked && box.value === value;
    });
  }

  function validateBeforeDownload() {
    clearMissingHighlights();

    const missing = [];

    requiredFields.forEach(function (field) {
      let ok = false;

      if (field.type === 'checked') {
        ok = fieldHasValue(field.name);
      } else {
        ok = fieldHasValue(field.name);
      }

      if (!ok) {
        missing.push(field.label + (field.hint ? ' — ' + field.hint : ''));
        highlightField(field.name);
      }
    });

    requiredConfirmations.forEach(function (field) {
      const ok = confirmationChecked(field.name, field.value);

      if (!ok) {
        missing.push(field.label);
        highlightField(field.name);
      }
    });

    if (missing.length) {
      alert(
        'Bitte ergänzen Sie noch folgende Pflichtangaben oder schreiben Sie ausdrücklich „keine“ / „nicht bekannt“:\n\n' +
        missing.map(function (item) { return '– ' + item; }).join('\n')
      );

      const first = document.querySelector('#produktberatungForm .pb-missing-field');
      if (first && typeof first.scrollIntoView === 'function') {
        first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      return false;
    }

    return true;
  }

  function formDataAsObject() {
    const form = getForm();

    if (!form) {
      alert('Das Formular wurde nicht gefunden. Bitte prüfen, ob die Seite das Element mit id="produktberatungForm" enthält.');
      return null;
    }

    const data = {};
    const elements = Array.from(form.elements).filter(function (el) {
      return el.name;
    });

    elements.forEach(function (el) {
      if (el.type === 'checkbox') {
        if (!data[el.name]) data[el.name] = [];
        if (el.checked) data[el.name].push(el.value);
      } else if (el.type === 'radio') {
        if (el.checked) {
          data[el.name] = el.value;
        } else if (!(el.name in data)) {
          data[el.name] = '';
        }
      } else {
        data[el.name] = el.value;
      }
    });

    data._formular = 'Produktberatungsfragebogen AFEGA';
    data._exportiert_am = new Date().toISOString();

    return data;
  }

  function formDataAsPrintableRows() {
    const form = getForm();
    if (!form) return [];

    const elements = Array.from(form.elements).filter(function (el) {
      return el.name && !['button', 'submit', 'reset'].includes(el.type);
    });

    const names = Array.from(new Set(elements.map(function (el) {
      return el.name;
    })));

    const rows = [];

    names.forEach(function (name) {
      const group = elements.filter(function (el) {
        return el.name === name;
      });

      if (!group.length) return;

      const first = group[0];
      const label = getQuestionLabel(first);
      let value = '';

      if (first.type === 'checkbox') {
        const selected = group
          .filter(function (el) {
            return el.type === 'checkbox' && el.checked;
          })
          .map(function (el) {
            return getOptionLabel(el);
          })
          .filter(Boolean);

        value = selected.length ? selected.join(', ') : '';
      } else if (first.type === 'radio') {
        const selectedRadio = group.find(function (el) {
          return el.type === 'radio' && el.checked;
        });

        value = selectedRadio ? getOptionLabel(selectedRadio) : '';
      } else if (first.tagName && first.tagName.toLowerCase() === 'select') {
        value = first.value || '';
      } else {
        value = first.value || '';
      }

      value = String(value || '').trim();

      if (value) {
        rows.push({
          section: getSectionTitle(first),
          label: label,
          value: value
        });
      }
    });

    return rows;
  }

  function escapeHtml(text) {
    return String(text || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function renderPrintableHtml() {
    const rows = formDataAsPrintableRows();
    const data = formDataAsObject() || {};
    const name = data.pseudonym || 'Kunde/Kundin';
    const datum = data.datum || new Date().toLocaleDateString('de-DE');

    let currentSection = '';
    let body = '';

    rows.forEach(function (row) {
      if (row.section !== currentSection) {
        currentSection = row.section;
        body += '<h2>' + escapeHtml(currentSection) + '</h2>';
      }

      body += '<div class="qa">';
      body += '<div class="question">' + escapeHtml(row.label) + '</div>';
      body += '<div class="answer">' + escapeHtml(row.value).replace(/\n/g, '<br>') + '</div>';
      body += '</div>';
    });

    if (!rows.length) {
      body = '<p>Es wurden noch keine Antworten eingetragen.</p>';
    }

    return '<!doctype html>' +
      '<html lang="de">' +
      '<head>' +
      '<meta charset="utf-8">' +
      '<title>Produktberatung – Antworten</title>' +
      '<style>' +
      'body{font-family:system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;color:#1d1f23;line-height:1.45;margin:32px;}' +
      'h1{font-size:26px;margin:0 0 8px;}' +
      '.meta{color:#667085;margin:0 0 28px;font-size:13px;}' +
      'h2{font-size:19px;margin:28px 0 12px;padding-top:12px;border-top:1px solid #d9dee7;}' +
      '.qa{break-inside:avoid;border-bottom:1px solid #eef0f3;padding:10px 0 12px;}' +
      '.question{font-weight:750;color:#24313f;margin-bottom:5px;}' +
      '.answer{white-space:normal;color:#111827;}' +
      '.hint{margin-top:28px;padding:12px 14px;border:1px solid #b9d8d4;background:#e7f3f1;border-radius:12px;color:#164a46;font-size:13px;}' +
      '@media print{body{margin:18mm;} .qa{break-inside:avoid;} }' +
      '</style>' +
      '</head>' +
      '<body>' +
      '<h1>Produktberatungs-Fragebogen</h1>' +
      '<p class="meta">Pseudonym/Vorname: ' + escapeHtml(name) + '<br>Datum: ' + escapeHtml(datum) + '<br>Erzeugt: ' + escapeHtml(new Date().toLocaleString('de-DE')) + '</p>' +
      body +
      '<div class="hint">Diese PDF-Zusammenfassung wurde aus den aktuell im Browser sichtbaren Formularangaben erzeugt. Checkboxen, Auswahlfelder und Skalen werden als Textwerte ausgegeben.</div>' +
      '</body>' +
      '</html>';
  }

  function downloadPrintableHtml() {
    const data = formDataAsObject() || {};
    const rawName = data.pseudonym || 'kunde';
    const safeName = rawName
      .replace(/[^a-z0-9\-_äöüß ]/gi, '')
      .trim()
      .replace(/\s+/g, '_') || 'kunde';

    const blob = new Blob([renderPrintableHtml()], { type: 'text/html;charset=utf-8' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = 'produktberatung_' + safeName + '_druckfassung.html';

    document.body.appendChild(link);
    link.click();
    link.remove();

    URL.revokeObjectURL(url);
    flash('Druckfassung wurde als HTML-Datei erstellt.');
  }

  function printFilledReport() {
    const htmlText = renderPrintableHtml();
    const printWindow = window.open('', '_blank');

    if (!printWindow) {
      downloadPrintableHtml();
      alert('Das Druckfenster wurde blockiert. Stattdessen wurde eine HTML-Zusammenfassung heruntergeladen. Diese Datei öffnen und dann als PDF speichern.');
      return;
    }

    printWindow.document.open();
    printWindow.document.write(htmlText);
    printWindow.document.close();

    setTimeout(function () {
      try {
        printWindow.focus();
        printWindow.print();
      } catch (e) {
        console.warn('Druck konnte nicht automatisch gestartet werden.', e);
      }
    }, 700);
  }

  function fillForm(data) {
    const form = getForm();
    if (!form || !data) return;

    const elements = Array.from(form.elements).filter(function (el) {
      return el.name;
    });

    elements.forEach(function (el) {
      const value = data[el.name];

      if (el.type === 'checkbox') {
        el.checked = Array.isArray(value) && value.includes(el.value);
      } else if (el.type === 'radio') {
        el.checked = value === el.value;
      } else if (value !== undefined && value !== null) {
        el.value = value;
      }
    });

    updateProgress();
  }

  function saveForm() {
    const data = formDataAsObject();
    if (!data) return;

    try {
      localStorage.setItem(storageKey, JSON.stringify(data));
      flash('Zwischengespeichert.');
    } catch (error) {
      alert('Die Eingaben konnten nicht zwischengespeichert werden. Möglicherweise blockiert der Browser lokale Speicherung.');
      console.error(error);
    }
  }

  function loadSaved() {
    try {
      const saved = localStorage.getItem(storageKey);
      if (saved) {
        fillForm(JSON.parse(saved));
      }
    } catch (error) {
      console.warn('Gespeicherte Daten konnten nicht geladen werden.', error);
    }
  }

  function clearSaved() {
    const form = getForm();

    if (!confirm('Gespeicherte Eingaben auf diesem Gerät wirklich löschen?')) return;

    try {
      localStorage.removeItem(storageKey);
      if (form) form.reset();
      updateProgress();
      flash('Gespeicherte Daten gelöscht.');
    } catch (error) {
      alert('Die gespeicherten Daten konnten nicht gelöscht werden.');
      console.error(error);
    }
  }

  function downloadJSON() {
    if (!validateBeforeDownload()) return;

    const data = formDataAsObject();
    if (!data) return;

    const json = JSON.stringify(data, null, 2);
    const blob = new Blob([json], { type: 'application/json;charset=utf-8' });
    const url = URL.createObjectURL(blob);

    const rawName = data.pseudonym || 'kunde';
    const safeName = rawName
      .replace(/[^a-z0-9\-_äöüß ]/gi, '')
      .trim()
      .replace(/\s+/g, '_') || 'kunde';

    const link = document.createElement('a');
    link.href = url;
    link.download = 'produktberatung_' + safeName + '.json';

    document.body.appendChild(link);
    link.click();
    link.remove();

    URL.revokeObjectURL(url);
    flash('JSON-Datei wurde erstellt.');
  }

  function updateProgress() {
    const form = getForm();
    if (!form) return;

    const elements = Array.from(form.elements).filter(function (el) {
      return el.name && !['button', 'submit', 'reset'].includes(el.type);
    });

    const names = Array.from(new Set(elements.map(function (el) {
      return el.name;
    })));

    let filled = 0;

    names.forEach(function (name) {
      const group = elements.filter(function (el) {
        return el.name === name;
      });

      const anyFilled = group.some(function (el) {
        if (el.type === 'checkbox' || el.type === 'radio') return el.checked;
        return String(el.value || '').trim().length > 0;
      });

      if (anyFilled) filled++;
    });

    const percent = names.length ? Math.round((filled / names.length) * 100) : 0;

    const progressText = document.getElementById('produktberatungProgressText');
    const progressBar = document.getElementById('produktberatungProgressBar');

    if (progressText) progressText.textContent = percent + '%';
    if (progressBar) progressBar.style.width = percent + '%';
  }

  let flashTimer;

  function flash(text) {
    clearTimeout(flashTimer);

    const old = document.getElementById('pb-flashMessage');
    if (old) old.remove();

    const msg = document.createElement('div');
    msg.id = 'pb-flashMessage';
    msg.textContent = text;
    msg.style.position = 'fixed';
    msg.style.right = '18px';
    msg.style.bottom = '18px';
    msg.style.background = '#176b67';
    msg.style.color = 'white';
    msg.style.padding = '12px 16px';
    msg.style.borderRadius = '999px';
    msg.style.boxShadow = '0 12px 35px rgba(0,0,0,.18)';
    msg.style.zIndex = '999999';
    msg.style.fontFamily = 'system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif';

    document.body.appendChild(msg);
    flashTimer = setTimeout(function () { msg.remove(); }, 2200);
  }

  function bindButtons() {
    const form = getForm();

    if (!form) {
      console.warn('Produktberatung: Formular mit id="produktberatungForm" nicht gefunden.');
      return;
    }

    const buttons = Array.from(form.querySelectorAll('button'));

    buttons.forEach(function (button) {
      const text = (button.textContent || '').trim().toLowerCase();

      button.removeAttribute('onclick');
      button.onclick = null;

      if (text.includes('zwischenspeichern')) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          saveForm();
        }, true);
      }

      if (text.includes('antworten herunterladen')) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          downloadJSON();
        }, true);
      }

      if (text.includes('gespeicherte daten löschen')) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          clearSaved();
        }, true);
      }

      if (text.includes('drucken')) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          printFilledReport();
        }, true);
      }
    });

    form.addEventListener('input', function () {
      clearMissingHighlights();
      updateProgress();

      try {
        const data = formDataAsObject();
        if (data) localStorage.setItem(storageKey, JSON.stringify(data));
      } catch (error) {
        console.warn('Automatische Zwischenspeicherung nicht möglich.', error);
      }
    });

    form.addEventListener('change', function () {
      clearMissingHighlights();
      updateProgress();

      try {
        const data = formDataAsObject();
        if (data) localStorage.setItem(storageKey, JSON.stringify(data));
      } catch (error) {
        console.warn('Automatische Zwischenspeicherung nicht möglich.', error);
      }
    });

    loadSaved();
    updateProgress();

    console.log('Produktberatung: JavaScript erfolgreich geladen.');
  }

  window.produktberatungSaveForm = saveForm;
  window.produktberatungDownloadJSON = downloadJSON;
  window.produktberatungClearSaved = clearSaved;
  window.produktberatungPrintFilledReport = printFilledReport;
  window.produktberatungValidateBeforeDownload = validateBeforeDownload;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindButtons);
  } else {
    bindButtons();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiefenfragebogen-biografie"] && !Shopify.designMode) return;
  try {
    
(function () {
  const storageKey = 'tiefenfragebogen_biografie_v1';

  function getForm() {
    return document.getElementById('tiefenForm');
  }

  function cleanText(text) {
    return String(text || '').replace(/\s+/g, ' ').trim();
  }

  function getSectionTitle(el) {
    const card = el.closest('section.card');
    if (!card) return 'Allgemeines';
    const h2 = card.querySelector('h2');
    return h2 ? cleanText(h2.textContent) : 'Allgemeines';
  }

  function getQuestionLabel(el) {
    const sentenceLabel = el.closest('label.sentence');
    if (sentenceLabel) {
      const span = sentenceLabel.querySelector('span');
      if (span) return cleanText(span.textContent);
    }

    const directLabel = el.closest('label.field');
    if (directLabel) {
      const clone = directLabel.cloneNode(true);
      clone.querySelectorAll('input, textarea, select').forEach(function (node) {
        node.remove();
      });
      return cleanText(clone.textContent);
    }

    const field = el.closest('.field');
    if (field) {
      const strong = field.querySelector('strong');
      if (strong) return cleanText(strong.textContent);
    }

    const details = el.closest('details');
    if (details) {
      const summary = details.querySelector('summary');
      if (summary) return cleanText(summary.textContent);
    }

    const card = el.closest('section.card');
    if (card) {
      const h2 = card.querySelector('h2');
      if (h2) return cleanText(h2.textContent);
    }

    return el.name || 'Feld';
  }

  function getOptionLabel(el) {
    const label = el.closest('label');
    if (!label) return el.value || '';
    const clone = label.cloneNode(true);
    clone.querySelectorAll('input').forEach(function (node) {
      node.remove();
    });
    return cleanText(clone.textContent) || el.value || '';
  }

  function formDataAsObject() {
    const form = getForm();
    if (!form) {
      alert('Das Formular wurde nicht gefunden. Bitte prüfen, ob die Seite das Element mit id="tiefenForm" enthält.');
      return null;
    }

    const data = {};
    const elements = Array.from(form.elements).filter(function (el) {
      return el.name;
    });

    elements.forEach(function (el) {
      if (el.type === 'checkbox') {
        if (!data[el.name]) data[el.name] = [];
        if (el.checked) data[el.name].push(el.value);
      } else if (el.type === 'radio') {
        if (el.checked) {
          data[el.name] = el.value;
        } else if (!(el.name in data)) {
          data[el.name] = '';
        }
      } else {
        data[el.name] = el.value;
      }
    });

    data._formular = 'Tiefenfragebogen Biografie';
    data._exportiert_am = new Date().toISOString();

    return data;
  }

  function formDataAsPrintableRows() {
    const form = getForm();
    if (!form) return [];

    const elements = Array.from(form.elements).filter(function (el) {
      return el.name && !['button', 'submit', 'reset'].includes(el.type);
    });

    const names = Array.from(new Set(elements.map(function (el) {
      return el.name;
    })));

    const rows = [];

    names.forEach(function (name) {
      const group = elements.filter(function (el) {
        return el.name === name;
      });

      if (!group.length) return;

      const first = group[0];
      const label = getQuestionLabel(first);
      let value = '';

      if (first.type === 'checkbox') {
        const selected = group
          .filter(function (el) {
            return el.type === 'checkbox' && el.checked;
          })
          .map(function (el) {
            return getOptionLabel(el);
          })
          .filter(Boolean);

        value = selected.length ? selected.join(', ') : '';
      } else if (first.type === 'radio') {
        const selectedRadio = group.find(function (el) {
          return el.type === 'radio' && el.checked;
        });

        value = selectedRadio ? getOptionLabel(selectedRadio) : '';
      } else {
        value = first.value || '';
      }

      value = String(value || '').trim();

      if (value) {
        rows.push({
          section: getSectionTitle(first),
          label: label,
          value: value
        });
      }
    });

    return rows;
  }

  function escapeHtml(text) {
    return String(text || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function renderPrintableHtml() {
    const rows = formDataAsPrintableRows();
    const data = formDataAsObject() || {};
    const name = data.name || 'Klient/in';
    const datum = data.datum || new Date().toLocaleDateString('de-DE');

    let currentSection = '';
    let body = '';

    rows.forEach(function (row) {
      if (row.section !== currentSection) {
        currentSection = row.section;
        body += '<h2>' + escapeHtml(currentSection) + '</h2>';
      }

      body += '<div class="qa">';
      body += '<div class="question">' + escapeHtml(row.label) + '</div>';
      body += '<div class="answer">' + escapeHtml(row.value).replace(/\n/g, '<br>') + '</div>';
      body += '</div>';
    });

    if (!rows.length) {
      body = '<p>Es wurden noch keine Antworten eingetragen.</p>';
    }

    return '<!doctype html>' +
      '<html lang="de">' +
      '<head>' +
      '<meta charset="utf-8">' +
      '<title>Tiefenfragebogen – Antworten</title>' +
      '<style>' +
      'body{font-family:system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;color:#1d1f23;line-height:1.45;margin:32px;}' +
      'h1{font-size:26px;margin:0 0 8px;}' +
      '.meta{color:#667085;margin:0 0 28px;font-size:13px;}' +
      'h2{font-size:19px;margin:28px 0 12px;padding-top:12px;border-top:1px solid #d9dee7;}' +
      '.qa{break-inside:avoid;border-bottom:1px solid #eef0f3;padding:10px 0 12px;}' +
      '.question{font-weight:750;color:#24313f;margin-bottom:5px;}' +
      '.answer{white-space:normal;color:#111827;}' +
      '.hint{margin-top:28px;padding:12px 14px;border:1px solid #b9d8d4;background:#e7f3f1;border-radius:12px;color:#164a46;font-size:13px;}' +
      '@media print{body{margin:18mm;} .qa{break-inside:avoid;} }' +
      '</style>' +
      '</head>' +
      '<body>' +
      '<h1>Tiefenfragebogen zur Lebensgeschichte</h1>' +
      '<p class="meta">Name: ' + escapeHtml(name) + '<br>Datum: ' + escapeHtml(datum) + '<br>Erzeugt: ' + escapeHtml(new Date().toLocaleString('de-DE')) + '</p>' +
      body +
      '<div class="hint">Diese PDF-Zusammenfassung wurde aus den aktuell im Browser sichtbaren Formularangaben erzeugt. Checkboxen und Auswahlfelder werden als Textwerte ausgegeben.</div>' +
      '</body>' +
      '</html>';
  }

  function downloadPrintableHtml() {
    const data = formDataAsObject() || {};
    const rawName = data.name || 'klient';
    const safeName = rawName
      .replace(/[^a-z0-9\-_äöüß ]/gi, '')
      .trim()
      .replace(/\s+/g, '_') || 'klient';

    const blob = new Blob([renderPrintableHtml()], { type: 'text/html;charset=utf-8' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = 'tiefenfragebogen_' + safeName + '_druckfassung.html';

    document.body.appendChild(link);
    link.click();
    link.remove();

    URL.revokeObjectURL(url);
    flash('Druckfassung wurde als HTML-Datei erstellt.');
  }

  function printFilledReport() {
    const htmlText = renderPrintableHtml();
    const printWindow = window.open('', '_blank');

    if (!printWindow) {
      downloadPrintableHtml();
      alert('Das Druckfenster wurde blockiert. Stattdessen wurde eine HTML-Zusammenfassung heruntergeladen. Diese Datei öffnen und dann als PDF speichern.');
      return;
    }

    printWindow.document.open();
    printWindow.document.write(htmlText);
    printWindow.document.close();

    setTimeout(function () {
      try {
        printWindow.focus();
        printWindow.print();
      } catch (e) {
        console.warn('Druck konnte nicht automatisch gestartet werden.', e);
      }
    }, 700);
  }

  function fillForm(data) {
    const form = getForm();
    if (!form || !data) return;

    const elements = Array.from(form.elements).filter(function (el) {
      return el.name;
    });

    elements.forEach(function (el) {
      const value = data[el.name];

      if (el.type === 'checkbox') {
        el.checked = Array.isArray(value) && value.includes(el.value);
      } else if (el.type === 'radio') {
        el.checked = value === el.value;
      } else if (value !== undefined && value !== null) {
        el.value = value;
      }
    });

    updateProgress();
  }

  function saveForm() {
    const data = formDataAsObject();
    if (!data) return;

    try {
      localStorage.setItem(storageKey, JSON.stringify(data));
      flash('Zwischengespeichert.');
    } catch (error) {
      alert('Die Eingaben konnten nicht zwischengespeichert werden. Möglicherweise blockiert der Browser lokale Speicherung.');
      console.error(error);
    }
  }

  function loadSaved() {
    try {
      const saved = localStorage.getItem(storageKey);
      if (saved) fillForm(JSON.parse(saved));
    } catch (error) {
      console.warn('Gespeicherte Daten konnten nicht geladen werden.', error);
    }
  }

  function clearSaved() {
    const form = getForm();
    if (!confirm('Gespeicherte Eingaben auf diesem Gerät wirklich löschen?')) return;

    try {
      localStorage.removeItem(storageKey);
      if (form) form.reset();
      updateProgress();
      flash('Gespeicherte Daten gelöscht.');
    } catch (error) {
      alert('Die gespeicherten Daten konnten nicht gelöscht werden.');
      console.error(error);
    }
  }

  function downloadJSON() {
    const data = formDataAsObject();
    if (!data) return;

    const json = JSON.stringify(data, null, 2);
    const blob = new Blob([json], { type: 'application/json;charset=utf-8' });
    const url = URL.createObjectURL(blob);

    const rawName = data.name || 'klient';
    const safeName = rawName
      .replace(/[^a-z0-9\-_äöüß ]/gi, '')
      .trim()
      .replace(/\s+/g, '_') || 'klient';

    const link = document.createElement('a');
    link.href = url;
    link.download = 'tiefenfragebogen_' + safeName + '.json';

    document.body.appendChild(link);
    link.click();
    link.remove();

    URL.revokeObjectURL(url);

    flash('JSON-Datei wurde erstellt.');
  }

  function updateProgress() {
    const form = getForm();
    if (!form) return;

    const elements = Array.from(form.elements).filter(function (el) {
      return el.name && !['button', 'submit', 'reset'].includes(el.type);
    });

    const names = Array.from(new Set(elements.map(function (el) {
      return el.name;
    })));

    let filled = 0;

    names.forEach(function (name) {
      const group = elements.filter(function (el) {
        return el.name === name;
      });

      const anyFilled = group.some(function (el) {
        if (el.type === 'checkbox' || el.type === 'radio') return el.checked;
        return String(el.value || '').trim().length > 0;
      });

      if (anyFilled) filled++;
    });

    const percent = names.length ? Math.round((filled / names.length) * 100) : 0;

    const progressText = document.getElementById('progressText');
    const progressBar = document.getElementById('progressBar');

    if (progressText) progressText.textContent = percent + '%';
    if (progressBar) progressBar.style.width = percent + '%';
  }

  let flashTimer;

  function flash(text) {
    clearTimeout(flashTimer);

    const old = document.getElementById('tf-flashMessage');
    if (old) old.remove();

    const msg = document.createElement('div');
    msg.id = 'tf-flashMessage';
    msg.textContent = text;
    msg.style.position = 'fixed';
    msg.style.right = '18px';
    msg.style.bottom = '18px';
    msg.style.background = '#176b67';
    msg.style.color = 'white';
    msg.style.padding = '12px 16px';
    msg.style.borderRadius = '999px';
    msg.style.boxShadow = '0 12px 35px rgba(0,0,0,.18)';
    msg.style.zIndex = '999999';
    msg.style.fontFamily = 'system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif';

    document.body.appendChild(msg);

    flashTimer = setTimeout(function () {
      msg.remove();
    }, 2200);
  }

  function bindButtons() {
    const form = getForm();
    if (!form) {
      console.warn('Tiefenfragebogen: Formular mit id="tiefenForm" nicht gefunden.');
      return;
    }

    const buttons = Array.from(document.querySelectorAll('button'));

    buttons.forEach(function (button) {
      const text = (button.textContent || '').trim().toLowerCase();

      button.removeAttribute('onclick');
      button.onclick = null;

      if (text.includes('zwischenspeichern')) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          saveForm();
        }, true);
      }

      if (text.includes('antworten herunterladen')) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          downloadJSON();
        }, true);
      }

      if (text.includes('gespeicherte daten löschen')) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          clearSaved();
        }, true);
      }

      if (text.includes('drucken')) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          printFilledReport();
        }, true);
      }
    });

    form.addEventListener('input', function () {
      updateProgress();
      try {
        const data = formDataAsObject();
        if (data) localStorage.setItem(storageKey, JSON.stringify(data));
      } catch (error) {
        console.warn('Automatische Zwischenspeicherung nicht möglich.', error);
      }
    });

    form.addEventListener('change', function () {
      updateProgress();
      try {
        const data = formDataAsObject();
        if (data) localStorage.setItem(storageKey, JSON.stringify(data));
      } catch (error) {
        console.warn('Automatische Zwischenspeicherung nicht möglich.', error);
      }
    });

    loadSaved();
    updateProgress();

    console.log('Tiefenfragebogen: JavaScript erfolgreich geladen.');
  }

  window.saveForm = saveForm;
  window.downloadJSON = downloadJSON;
  window.clearSaved = clearSaved;
  window.updateProgress = updateProgress;
  window.printFilledReport = printFilledReport;
  window.downloadPrintableHtml = downloadPrintableHtml;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindButtons);
  } else {
    bindButtons();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
